/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { Property } from 'csstype';
import { getColorRamp } from '../../utils/UNSAFE_visUtils';
import { getMarkers } from './utils';
import { MarkerShapes } from '#utils/UNSAFE_visTypes/common';

export function getItemColor(
  seriesIndex: number,
  groupIndex: number,
  series: { color?: Property.Color; lineColor?: Property.Color; areaColor?: Property.Color }[],
  getDataItem: (
    seriesIndex: number,
    groupIndex: number
  ) => { color?: Property.Color; markerColor?: Property.Color } | undefined
) {
  const item = getDataItem(seriesIndex, groupIndex);
  if (item?.color) {
    return item.color;
  }

  if (item?.markerColor) {
    return item.markerColor;
  }
  const itemSeries = series[seriesIndex];

  const colors = getColorRamp();
  return (
    itemSeries.color ||
    itemSeries.lineColor ||
    itemSeries.areaColor ||
    colors[seriesIndex % colors.length]
  );
}

export function getMarkerType(
  seriesIndex: number,
  groupIndex: number,
  getDataItem: (
    seriesIndex: number,
    groupIndex: number
  ) => { markerType?: MarkerShapes } | undefined
) {
  const item = getDataItem(seriesIndex, groupIndex);
  if (item?.markerType) {
    return item.markerType;
  }
  const shapes = getMarkers();
  return shapes[seriesIndex % shapes.length];
}
